import * as React from "react";
import { motion } from "motion/react";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { getConcatClickTrackingAttributes } from "@grandvisionhq/svc-tealium/utils";
import { handleHrefClick } from "../../../../SiteNav/SiteNavMobile/helpers.js";
import SubMenuLinks from "./SubMenuLinks.js";
/* empty css             */
const subMenuContainer = {
  hidden: {
    x: "0%",
    // Instead of 1 SubMenu multiple can be rendered, make sure to hide the inactive ones
    display: "none",
    transition: {
      ease: "easeIn",
      duration: 0.3
    },
    transitionEnd: {
      display: "none"
    }
  },
  visible: {
    x: "-100%",
    display: "flex",
    transition: { duration: 0.3, ease: "easeOut" }
  }
};
const SubMenu = ({ active, menuItems, hideSubMenu }) => {
  const firstLink = React.useRef(null);
  React.useEffect(() => {
    if (active) {
      setTimeout(() => firstLink.current?.focus(), 50);
    }
  }, [active]);
  const keyUp = React.useCallback(
    (e) => {
      if (e.key === "Escape") {
        hideSubMenu(true);
        e.stopPropagation();
      }
    },
    [hideSubMenu]
  );
  return /* @__PURE__ */ React.createElement(
    motion.div,
    {
      className: "site-nav-mobile__page",
      animate: active ? "visible" : "hidden",
      variants: subMenuContainer,
      "aria-hidden": !active
    },
    /* @__PURE__ */ React.createElement("div", { className: "site-nav-mobile-submenu", onKeyUp: keyUp, role: "presentation" }, menuItems.map(({ childMenuItems, label, tealiumLabel, link, parameters }, index) => {
      const tealiumAttributes = getConcatClickTrackingAttributes(tealiumLabel ?? label, {
        "data-element-id": `MainNav`
      });
      return /* @__PURE__ */ React.createElement("div", { className: "site-nav-mobile-submenu__column", key: label }, link?.href ? /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "site-nav-mobile-submenu__link--mobile",
          onClick: handleHrefClick,
          href: link.href,
          ref: index === 0 ? firstLink : null,
          ...tealiumAttributes
        },
        parameters?.icon ? /* @__PURE__ */ React.createElement("span", { className: "site-nav-mobile-submenu__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: parameters.icon })) : null,
        label
      ) : /* @__PURE__ */ React.createElement(Heading, { variant: "small", className: "site-nav-mobile-submenu__title", component: "p" }, label), childMenuItems?.length ? /* @__PURE__ */ React.createElement(
        SubMenuLinks,
        {
          items: childMenuItems,
          ariaLabel: label,
          parentTealiumAttributes: tealiumAttributes
        }
      ) : null);
    }))
  );
};
export {
  SubMenu as default
};
//# sourceMappingURL=SubMenu.js.map
